export const LEASE_TERMS_IDENTIFIER = 'lease_terms';
export const RENTER_PROFILE_IDENTIFIER = 'renter_profile';
export const UNIT_NOT_HELD_WAITING_IDENTIFIER = 'unit_not_held_waiting';
export const VIEWED_RECEIPTS_PAGE = 'viewed_receipt';
export const DOCUMENT_SIGNED_PAGE = 'document_signed';
export const REQUESTED_GUARANTORS_ADDED = 'requested_guarantors_added';
export const PRICE_UPDATE = 'price_update';
export const UNIT_PRICE_CHANGED = 'unit_price_changed';
